import {Breakpoints, Image} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import React from 'react'
import {useSelector} from 'react-redux'
import {bannerTitle, bannerWrapper} from '../../../assets/css-vars/bannerUtils'
import TrackingAction from '../../../tracking-manager'
import {Banners} from '../../../types/singleModelInterface'
import {useFeatureServices} from '../../../use-feature-services'
import stripTags from '../../../utils/text/stripTags'
import {
    TRACKING,
    getVehiclePromotionsButtonClickData,
} from '../../../utils/tracking/getTrackingData'
import setTracking, {
    checkTrackingManager,
} from '../../../utils/tracking/tracking-utils/setTracking'
import {RootState} from '../../rootReducer'
import BannerSubTitle from './BannerSubTitle'

// tslint:disable-next-line:no-any
const borderColor = (props: any) => props.theme.colors.content.active

const SmallBannerItem = styled.a`
    --small-banner-border-width: 2px;
    --small-banner-padding-y: 25px;
    --small-banner-padding-x: 15px;

    ${bannerWrapper};

    text-decoration: none;
    color: ${(props) => props.theme.colors.content.primary};
    padding: var(--small-banner-padding-y) var(--small-banner-padding-x);
    border-bottom: var(--small-banner-border-width) solid;
    border-color: ${borderColor};
    border-right: 0;
    border-left: 0;

    &:first-child {
        border-top: var(--small-banner-border-width) solid ${borderColor};
    }

    @media only screen and (min-width: ${Breakpoints.b560}px) {
        --small-banner-padding-y: 0;
        --small-banner-padding-x: 0;

        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
        align-items: center;

        &,
        &:first-child {
            --small-banner-border-width: 0;
        }
    }

    @media only screen and (min-width: ${Breakpoints.b1280}px) {
        grid-template-columns: 240px 1fr;
    }
`

const SmallBannerImageWrapper = styled.div`
    display: none;
    align-self: start;
    overflow: hidden;

    @media only screen and (min-width: ${Breakpoints.b560}px) {
        display: block;
    }
`

const SmallBannerImage = styled(Image)`
    border-radius: 16px;
`

const SmallBannerMainTitle = styled.h2`
    font-size: ${({theme}) => theme.fonts.headline['200'].fontSize};
    line-height: ${({theme}) => theme.fonts.headline['200'].lineHeight};
    ${bannerTitle}

    p {
        margin: 0;
    }
`

export interface SmallBanner extends Banners {
    modelName: string
    modelSlug: string
}

export default function SmallBanner(props: SmallBanner): React.JSX.Element {
    const {tracking: trackingManager} = useFeatureServices()
    const trackingBrand = useSelector(
        (state: RootState) => state.general.trackingBrand
    )
    const isShowroom = useSelector(
        (state: RootState) => state.general.isShowroom
    )

    return (
        <SmallBannerItem
            href={props.cta_url}
            onClick={() => {
                if (checkTrackingManager(trackingManager)) {
                    const clickData = getVehiclePromotionsButtonClickData(
                        TRACKING.LINK_NAME_SMALL_BANNER_CLICK,
                        props.modelName,
                        props.modelSlug,
                        trackingBrand,
                        isShowroom,
                        stripTags(props.title)
                    )

                    setTracking(
                        trackingManager,
                        TrackingAction.VWBasic_VehiclePromotionsButton_Click,
                        clickData
                    )
                }
            }}
        >
            <SmallBannerImageWrapper>
                <SmallBannerImage src={props.image} alt="" />
            </SmallBannerImageWrapper>

            <div>
                {props.title.length ? (
                    <BannerSubTitle label={props.label} />
                ) : undefined}

                {props.title.length ? (
                    <SmallBannerMainTitle
                        dangerouslySetInnerHTML={{
                            __html: props.title,
                        }}
                    />
                ) : undefined}
            </div>
        </SmallBannerItem>
    )
}
